@for (campaign of comparableCampaigns; track campaign) {
  <div>
    <div class="h-full print:break-inside-avoid-page" [id]="campaign.campaignCode">
      <rma-market-report-comparable-property
        class="break-inside-avoid"
        [campaign]="campaign"
        [selected]="campaign.campaignCode === selectedItemId"
      />
    </div>
  </div>
}
